import React, { Fragment, useState } from 'react'
import { Formik, Form, Field, ErrorMessage, getIn } from 'formik';
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from 'react-router-dom'
import estilos from './AsociadosComponent.module.css'
import { agregarInstalacionAsociado, agregarLocalidad, editarLocalidad } from '../../../redux/DucksUnidadInspeccion/ZonasDuck'
import { ObtenerClientes } from '../../../redux/DucksAtencionACliente/ModuloConsultaDucks';

import { agregarAsociadoLocalidad } from '../../../redux/DucksUnidadInspeccion/AsociadosEnLaLocalidadDuck';
import { obtenerClienteConDetalle } from '../../../redux/DucksAtencionACliente/ModuloConsultaDucks';
import { getInstalacionesByCliente } from '../../../redux/DucksUnidadInspeccion/AsociadosDuck';
import { obtenerAsociadosLocalidad } from '../../../redux/DucksUnidadInspeccion/AsociadosEnLaLocalidadDuck';

import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux'

const AsociadoFormComponent = (props) => {

    const asociados = props.asociados
    const localidad = props.localidad
    const sublocalidad = props.sublocalidad
    const zona = props.zona
    const dispatch = useDispatch()
    const asociadoModify = props.asociadoModify
    const asociadosNuevos = useSelector(store => store.ModuloConsulta.clientes);
    const instalaciones = useSelector(store => store.Asociado.instalaciones);
    const [instalacionesCliente, setInstalacionesCliente] = React.useState([])
    const [asociadosLocalidad, setAsociadosLocalidad] = React.useState([])

    const [inicialStateFormik, setInicialStateFormik] = useState({
        idcliente: ''
    }
    )
    const [asociadoSelected, setAsociadoSelected] = React.useState({ id: undefined, instalaciones: [] })


    React.useEffect(() => {
        instalaciones
        //console.log(instalaciones)
        //console.log(asociadosLocalidad)
        let filter = []
        filter = instalaciones.filter(
            (item2) => !asociadosLocalidad.some((item1) => item2.idiformaciongeneralcliente === item1.anexocliente.idiformaciongeneralcliente))
        //console.log(filter)
        setInstalacionesCliente(filter)
    }, [instalaciones])

    React.useEffect(() => {
        instalacionesCliente
    }, [instalacionesCliente])

    React.useEffect(() => {
        dispatch(ObtenerClientes())
        dispatch(obtenerAsociadosLocalidad()).then((res) => {
            setAsociadosLocalidad(res.payload.data.data)
        })
    }, [])

    const handleOnChangue = (event) => {
        if (event.target.value == 0) {
            setAsociadoSelected({ id: undefined, instalaciones: [] })
        } else {
            if (event.target.name == 'idcliente') {
                const idAsociado = event.target.value
                const asociadox = asociados.find(asociado => asociado.idcliente == idAsociado)
                dispatch(getInstalacionesByCliente(idAsociado))
                setAsociadoSelected(asociadox)
            }
        }
    }

    return (
        <Fragment>
            <div className='row'>
                <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 ${estilos.contenedorBorder}`}>
                    <div className='row'>
                        <h1 className={`${estilos.tituloForm}`}>{
                            asociadoModify ?
                                "Editar Socio" :
                                `Añadir Socio en la Localidad `
                        }</h1>
                    </div>

                    <Formik
                        initialValues={inicialStateFormik}
                        validate={values => {
                            const errors = {};
                            if (values.idcliente == 0) {
                                errors.idcliente = 'Seleccione un asociado'
                            }

                            if (values.idanexocliente == 0) {
                                errors.idanexocliente = 'Seleccione una instalacion'
                            }


                            return errors;
                        }}
                        onSubmit={(values, { setSubmitting }) => {

                            //console.log(values)
                            values.idanexocliente.forEach((a) => {

                                let data = {
                                    data: {
                                        idanexocliente: Number(a),
                                        idzona: Number(zona.idzona),
                                    }
                                }
                                dispatch(agregarAsociadoLocalidad(data))
                            })

                            props.actualizarZonas()
                            props.handleCloseModalAgregarInstalacion()
                            //props.handleCloseModalAsociados()
                            setSubmitting(false);
                            props.onClose()
                        }}
                    >

                        {({ values, isSubmitting }) => (
                            <Form onChange={handleOnChangue}>
                                <div className={`container ${estilos.contenedorForm}`}>

                                    <Field type="hidden" name="id" className='form-control' />

                                    <div className='col'>
                                        <label htmlFor="idcliente">Asociados:</label><br />
                                        <Field as="select" name="idcliente" className='form-control'>
                                            {
                                                <option value={0}>Seleccione un asociado</option>
                                            }
                                            {
                                                asociadosNuevos.map((asociado, index) => (
                                                    <option key={asociado.idcliente} value={asociado.idcliente}>{asociado.numerosocio} | {asociado.nombrerazonsocial}</option>
                                                ))

                                            }
                                        </Field>
                                        <ErrorMessage name="idcliente" component="div" className={`${estilos.error}`} />
                                        <br />
                                    </div>

                                    {
                                        values.idcliente ?
                                            <div className='col'>
                                                <label htmlFor="idanexocliente">Seleccione una instalación:</label><br />
                                                <Field as="select" name="idanexocliente" className='form-control' multiple>
                                                    {
                                                        instalacionesCliente.map((instalacion, index) => (
                                                            <option key={instalacion.idanexocliente} value={instalacion.idiformaciongeneralcliente}>{instalacion.informaciongeneralinstalacioncliente.alias} | {instalacion.idtipoanexo == 1 ? 'UNIDAD DE PRODUCCION' : instalacion.idtipoanexo == 2 ? 'UNIDAD DE ENVASADO' : instalacion.idtipoanexo == 3 ? 'UNIDAD DE ALMACÉN' : ''}</option>
                                                        ))
                                                    }
                                                </Field>
                                                <ErrorMessage name="idanexocliente" component="div" className={`${estilos.error}`} />
                                            </div>
                                            :
                                            <hr />
                                    }
                                    <div className='text-center mt-5'>
                                        <button type="submit" disabled={isSubmitting} className='btn btn-lg btn-success'>
                                            Agregar Asociado
                                        </button>
                                    </div>

                                </div>
                            </Form>
                        )}

                    </Formik>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(AsociadoFormComponent)